"use client";

import { useOrganization, useUser } from "@repo/auth/client";
import { useEffect, useRef } from "react";
import { analytics } from "./client";

/**
 * Hook to automatically identify users in PostHog with Clerk user and organization data
 */
export const usePostHogIdentify = () => {
	const { user, isLoaded: userLoaded } = useUser();
	const { organization } = useOrganization();
	const identifiedRef = useRef(false);

	useEffect(() => {
		// Only identify once and when user is loaded
		if (!userLoaded || !user || !analytics || identifiedRef.current) {
			return;
		}

		// Prepare user properties
		const userProperties: Record<string, string | number | undefined | null> = {
			email: user.primaryEmailAddress?.emailAddress,
			name: user.fullName,
			firstName: user.firstName,
			lastName: user.lastName,
			username: user.username,
			createdAt: user.createdAt?.toISOString(),
			imageUrl: user.imageUrl,
		};

		// Add organization data as user properties (free plan friendly)
		if (organization) {
			userProperties.org_id = organization.id;
			userProperties.org_name = organization.name;
			userProperties.org_slug = organization.slug;
			userProperties.org_imageUrl = organization.imageUrl;
			userProperties.org_createdAt = organization.createdAt?.toISOString();
			userProperties.org_membersCount = organization.membersCount;
		}

		// Identify user with all properties
		analytics.identify(user.id, userProperties);

		identifiedRef.current = true;
	}, [user, userLoaded, organization]);
};
